import { render, staticRenderFns } from "./SurahAyah.vue?vue&type=template&id=1407a2b3&"
import script from "./SurahAyah.vue?vue&type=script&lang=js&"
export * from "./SurahAyah.vue?vue&type=script&lang=js&"
import style0 from "./SurahAyah.vue?vue&type=style&index=0&id=1407a2b3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports